module.exports = __webpack_public_path__ + "img/tech-master-event-logo.dab9b840.png";